import { Flex, Spacing, Text } from '@billy/design-system'
import { SystemBanner, SystemBannerType } from '@shinetools/lumen-react'
import { PropsWithChildren, ReactElement } from 'react'

export interface EInvoicingGenericStepProps {
  title?: string | ReactElement
  subtitle?: string | ReactElement
  fullwidth?: boolean
  bannerText?: string
  bannerType?: SystemBannerType
}

export const EInvoicingGenericStepBody = ({ children }: PropsWithChildren<{}>): ReactElement => {
  return <Flex justifyContent="center">{children}</Flex>
}

export const EInvoicingGenericStep = ({
  children,
  subtitle,
  title,
  bannerText,
  bannerType = 'info',
  fullwidth = false,
}: PropsWithChildren<EInvoicingGenericStepProps>): ReactElement => {
  return (
    <Flex gap={Spacing.S24} flexDirection="column" width={fullwidth ? '100%' : '500px'}>
      <Flex justifyContent="center" alignItems="center" flexDirection="column" gap={Spacing.S8}>
        {title && (
          <Text alignment="center" variant="h1">
            {title}
          </Text>
        )}
        {subtitle && (
          <Text alignment="center" variant="bodySM">
            {subtitle}
          </Text>
        )}
        {bannerText && <SystemBanner message={bannerText} type={bannerType} />}
      </Flex>
      {children}
    </Flex>
  )
}

EInvoicingGenericStep.Body = EInvoicingGenericStepBody
